import React from 'react';
import {Col, Form, Input, Row, Typography} from 'antd';
import {InfoCircleOutlined} from "@ant-design/icons";
import PropTypes from "prop-types";

import {GSTRegistrationNumberText, TaxRegistrationNumberText} from "../../helpers/text";
import {useGetCompanyInfoQuery} from "../../store/api/settingsApi";

const {Text} = Typography;

const BusinessInformationForm = ({
                                            businessName,
                                            setBusinessName,
                                            nameOnContract,
                                            setNameOnContract,
                                            dbaName,
                                            setDBAName,
                                            websiteAddress,
                                            setWebsiteAddress,
                                            taxRegistrationNumber,
                                            setTaxRegistrationNumber,
                                            businessRegistrationNumber,
                                            setBusinessRegistrationNumber,
                                            industryCode,
                                            setIndustryCode,
                                            companySize,
                                            setCompanySize,
                                          }) => {
    // The terminology for a tax number differs between CA and US.
    const {data: clientInfo} = useGetCompanyInfoQuery();
    const taxNumberText = clientInfo.country === 'CA' ? GSTRegistrationNumberText : TaxRegistrationNumberText;

    const handleBusinessNameChange = (e) => {
        setBusinessName(e.target.value.trim());
    }

    const handleNameOnContractChange = (e) => {
        setNameOnContract(e.target.value.trim());
    }

    const handleDBANameChange = (e) => {
        setDBAName(e.target.value.trim());
    }

    const handleWebsiteAddressChange = (e) => {
        setWebsiteAddress(e.target.value.trim());
    }

    const handleTaxRegistrationNumberChange = (e) => {
        setTaxRegistrationNumber(e.target.value.trim());
    }

    const handleBusinessRegistrationNumberChange = (e) => {
        setBusinessRegistrationNumber(e.target.value.trim());
    }

    const handleIndustryCodeChange = (e) => {
        setIndustryCode(e.target.value.trim());
    }

    const handleCompanySizeChange = (e) => {
        setCompanySize(e.target.value.trim());
    }

    return (
        <Row gutter={16} className="business-information-form">
            <Col xs={24} sm={24} md={12}>
                <Form.Item>
                    <Text strong className="account-create-information-sub-title">Company Information</Text>
                </Form.Item>
                <Form.Item
                    name="Business Name"
                    label="Business Name"
                    rules={[{type: 'string', required: true}]}
                    initialValue={businessName}
                >
                    <Input name="businessName" onChange={handleBusinessNameChange}/>
                </Form.Item>
                <Form.Item
                    name="Name on Contract"
                    label="Name on Contract"
                    rules={[{type: 'string', required: true}]}
                    initialValue={nameOnContract}
                >
                    <Input name="nameOnContract" onChange={handleNameOnContractChange}/>
                </Form.Item>
                <Form.Item
                    name="DBA Name"
                    label="DBA Name"
                    initialValue={dbaName}
                >
                    <Input name="dbaName" onChange={handleDBANameChange}/>
                </Form.Item>
                <Form.Item
                    name="Website Address"
                    label="Website Address"
                    initialValue={websiteAddress}
                >
                    <Input name="websiteAddress" onChange={handleWebsiteAddressChange}/>
                </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
                {/* Empty Form.Item is used to drop 2nd column below header*/}
                <Form.Item />
                <Form.Item
                    name="Tax Registration Number"
                    label={taxNumberText}
                    tooltip={{
                        title: `Either the ${taxNumberText} or Business Registration Number must be provided`,
                        icon: <InfoCircleOutlined/>
                    }}
                    initialValue={taxRegistrationNumber}
                >
                    <Input name="taxRegistrationNumber" onChange={handleTaxRegistrationNumberChange}/>
                </Form.Item>
                <Form.Item
                    name="Business Registration Number"
                    label="Business Registration Number"
                    tooltip={{
                        title: `Either the ${taxNumberText} or Business Registration Number must be provided`,
                        icon: <InfoCircleOutlined/>
                    }}
                    initialValue={businessRegistrationNumber}
                >
                    <Input name="businessRegistrationNumber"
                           onChange={handleBusinessRegistrationNumberChange}/>
                </Form.Item>
                <Form.Item
                    name="Industry Code"
                    label="Industry Code"
                    tooltip={{title: 'Per NAICS 3.0', icon: <InfoCircleOutlined/>}}
                    initialValue={industryCode}
                >
                    <Input name="industryCode" onChange={handleIndustryCodeChange}/>
                </Form.Item>
                <Form.Item
                    name="Company Size"
                    label="Company Size"
                    initialValue={companySize}
                >
                    <Input name="companySize" onChange={handleCompanySizeChange}/>
                </Form.Item>
            </Col>
        </Row>
    )
}

export default BusinessInformationForm;

BusinessInformationForm.propTypes = {
    businessName: PropTypes.string,
    setBusinessName: PropTypes.func.isRequired,
    nameOnContract: PropTypes.string,
    setNameOnContract: PropTypes.func.isRequired,
    dbaName: PropTypes.string,
    setDBAName: PropTypes.func.isRequired,
    websiteAddress: PropTypes.string,
    setWebsiteAddress: PropTypes.func.isRequired,
    taxRegistrationNumber: PropTypes.string,
    setTaxRegistrationNumber: PropTypes.func.isRequired,
    businessRegistrationNumber: PropTypes.string,
    setBusinessRegistrationNumber: PropTypes.func.isRequired,
    industryCode: PropTypes.string,
    setIndustryCode: PropTypes.func.isRequired,
    companySize: PropTypes.string,
    setCompanySize: PropTypes.func.isRequired,

};
